import React from 'react';
export var ContextualToolbarIcon = function ContextualToolbarIcon(props) {
  var primaryColor = props.primaryColor,
    label = props.label;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    style: {
      color: primaryColor,
      // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
      fill: "var(--ds-background-neutral-subtle, #00000000)"
    },
    "aria-label": label || undefined,
    role: label ? 'img' : 'presentation'
  }, /*#__PURE__*/React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M14 8.75H2V7.25H14V8.75Z",
    fill: "currentColor"
  }));
};